import { events } from '..';
import track from '../track';

export function trackScrollPastBowlSection() {
  track(events.homepage_scroll_past_bowl_section);
}
